"use client";
'use strict';

var React = require('react');
var FormControlProvider = require('../providers/FormControlProvider.js');

function useFormControlContext() {
    return React.useContext(FormControlProvider.FormControlContext);
}

exports.useFormControlContext = useFormControlContext;
//# sourceMappingURL=useFormControlContext.js.map
